import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppConfigService } from '../../app-config.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdSection } from '../../constants';
import { selectApiDataSections } from '../../core/store/api-data';
import { ApiDataSection } from '../../core/interfaces';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public buildNumber: string = '';
  public feedbackStr: string;
  public sectionNamesById$: Observable<Record<number, string>>;
  public readonly sectionID: typeof IdSection = IdSection;

  public currentYear: number = new Date().getFullYear();

  constructor(
    public config: AppConfigService,
    private store: Store,
  ) {
    this.buildNumber = environment.buildNumber || '';
    this.feedbackStr = `${this.config.ppUrl}/Feedback`;
  }

  public ngOnInit(): void {
    this.sectionNamesById$ = this.store.select(selectApiDataSections).pipe(
      map((sections: ApiDataSection[]) =>
        sections.reduce((acc: Record<number, string>, section: ApiDataSection) => {
          acc[Number(section.id)] = section.name;
          return acc;
        }, {} as Record<number, string>)
      )
    );
  }

}
